<template>
  <svg
    :width="width ? width : height ? height * (17 / 13) : 17"
    :height="height ? height : width ? width * (13 / 17) : 13"
    viewBox="0 0 17 13"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <g
      id="Reiseplanlegger"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g
        id="Evt-forside"
        transform="translate(-91.000000, -783.000000)"
        :fill="iconColor"
        fill-rule="nonzero"
      >
        <path
          d="M107.663726,787.341662 C107.785601,787.244787 107.966851,787.335412 107.966851,787.488537 L107.966851,793.879162 C107.966851,794.707287 107.294976,795.379162 106.466851,795.379162 L93.4668507,795.379162 C92.6387257,795.379162 91.9668507,794.707287 91.9668507,793.879162 L91.9668507,787.491662 C91.9668507,787.335412 92.1449757,787.247912 92.2699757,787.344787 C92.9699757,787.888537 93.8981007,788.579162 97.0856007,790.894787 C97.7449757,791.376037 98.8574757,792.388537 99.9668507,792.382287 C101.082476,792.391662 102.216851,791.357287 102.851226,790.894787 C106.038726,788.579162 106.963726,787.885412 107.663726,787.341662 Z M99.9668507,791.379162 C100.691851,791.391662 101.735601,790.466662 102.260601,790.085412 C106.407476,787.076037 106.723101,786.813537 107.679351,786.063537 C107.860601,785.922912 107.966851,785.704162 107.966851,785.472912 L107.966851,784.879162 C107.966851,784.051037 107.294976,783.379162 106.466851,783.379162 L93.4668507,783.379162 C92.6387257,783.379162 91.9668507,784.051037 91.9668507,784.879162 L91.9668507,785.472912 C91.9668507,785.704162 92.0731007,785.919787 92.2543507,786.063537 C93.2106007,786.810412 93.5262257,787.076037 97.6731007,790.085412 C98.1981007,790.466662 99.2418507,791.391662 99.9668507,791.379162 Z"
          id="Shape"
        ></path>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'mail',
  props: {
    iconColor: {
      type: String,
      default: '#D2D5E4',
    },
    height: {
      type: Number,
      required: false,
    },
    width: {
      type: Number,
      required: false,
    },
  },
};
</script>
